import { ComponentPropsWithoutRef, FC, ReactNode, Ref } from 'react';
import classNames from 'classnames';

import styles from './ModalFooter.module.css';

export type ModalFooterDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';

export type ModalFooterProps = {
  children?: ReactNode;
  className?: string;
  /** Порядок кнопок. По умолчанию `'row'` — первый ребёнок слева, группа прижата к правому краю. */
  direction?: ModalFooterDirection;
  ref?: Ref<HTMLDivElement>;
} & Omit<ComponentPropsWithoutRef<'div'>, 'className'>;

const DIRECTION_CLASS_NAME: Record<ModalFooterDirection, string | undefined> = {
  row: undefined,
  'row-reverse': styles.directionRowReverse,
  column: styles.directionColumn,
  'column-reverse': styles.directionColumnReverse,
};

/** Футер модалки, закреплён под Body. Без Footer кнопки скроллятся вместе с контентом. */
const ModalFooter: FC<ModalFooterProps> = ({ children, className, direction = 'row', ref, ...rest }) => (
  <div
    ref={ref}
    {...rest}
    className={classNames(styles.footer, DIRECTION_CLASS_NAME[direction], className)}>
    {children}
  </div>
);

export default ModalFooter;
